import Header from './Header.vue';

export default Header;



// WEBPACK FOOTER //
// ./src/pages/profile/components/header/index.ts